<div *ngIf="apiLoaded" class="complaint-map">
    <google-map
        height="800"
        width="100%"
        [zoom]="mapZoom"
        [center]="mapCenter"
        [options]="{ mapId: 'DEMO_MAP_ID' }"
        #complaintsMap
        (centerChanged)="onCenterChanged()"
        (zoomChanged)="onZoomChanged()"
    >
    </google-map>
</div>

<ng-template
    #infoWindowTemplate let-complaint="data"
    let-appointmentCount="appointmentCount"
    let-closestAppointmentScheduledTime="closestAppointmentScheduledTime"
    let-closestAppointmentDate="closestAppointmentDate"
    >
    <div class="complaint-info">
        <div class="complaint-info__details">
            <div class="complaint-info__row">
                <span class="complaint-info__label">{{ 'COMPLAINT|Indywidualny numer reklamacji:' | translate }}</span>
                <span class="complaint-info__data">{{ complaint.documentName ?? ('INTERFACE|Brak' | translate) }}</span>
            </div>
            <div class="complaint-info__row">
                <span class="complaint-info__label">{{ 'COMPLAINT|Priorytet:' | translate }}</span>
                <span [id]="'priorityValue' + complaint.uuid" style="display: flex; align-items: center;">
                    <span>
                        {{ getPriority(complaint) }}
                    </span>
                    <button iccIconButton *ngIf="hasAccessTo.manageComplaint" appearance="flat" [id]="'editButton' + complaint.uuid" (click)="showEditMode(complaint.uuid)">
                        <icc-icon name="edit"></icc-icon>
                    </button>
                </span>
                <div class="priority-edit" [id]="'priorityEdit' + complaint.uuid" style="display: none;">
                    <div class="priority-edit-container">
                        <icc-select
                            [value]="priorityMap[complaint.uuid].slice(0, 1)"
                            (valueChange)="priorityGroup = $event"
                            size="small"
                            [required]="true"
                            class="priority-edit-container__select"
                        >
                            <option *ngFor="let priority of documentPriorities" [value]="priority.value">
                                {{ priority.label | translate }}
                            </option>
                        </icc-select>
                        <div>-</div>
                        <input
                            [value]="priorityMap[complaint.uuid].slice(-2)"
                            [id]="'priorityInput' + complaint.uuid"
                            name="priorityValue"
                            type="number"
                            [min]="1"
                            [max]="99"
                            [title]="'COMPLAINT|Wartość musi mieścić się w zakresie od 1 do 99' | translate"
                            class="priority-edit-container__input-map"
                            #priorityInput
                        />
                    </div>
                    <div>
                        <button
                            iccIconButton
                            appearance="flat"
                            (click)="changePriority(complaint, priorityGroup, priorityInput.value)"
                            [id]="'saveButton' + complaint.uuid"
                        >
                            <icc-icon name="done"></icc-icon>
                        </button>
                        <button
                            iccIconButton
                            appearance="flat"
                            (click)="cancelEditPriority(complaint.uuid)"
                            [id]="'cancelButton' + complaint.uuid"
                        >
                            <icc-icon name="close"></icc-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="complaint-info__row">
                <span class="complaint-info__label">{{ 'COMPLAINT|Liczba przyszłych wizyt:' | translate }}</span>
                <span class="complaint-info__data">{{ appointmentCount }}</span>
            </div>
            <div class="complaint-info__row" *ngIf="closestAppointmentDate">
                <span class="complaint-info__label">{{ 'COMPLAINT|Data najbliższej wizyty:' | translate }}</span>
                <span class="complaint-info__data">{{ closestAppointmentDate | date: 'shortDate' }}</span>
            </div>
            <div class="complaint-info__row" *ngIf="closestAppointmentScheduledTime">
                <span class="complaint-info__label">{{ 'COMPLAINT|Planowany czas najbliższej wizyty:' | translate }}</span>
                <span class="complaint-info__data" *ngIf="closestAppointmentScheduledTime < 60">
                    {{ closestAppointmentScheduledTime }} min
                </span>
                <span class="complaint-info__data" *ngIf="closestAppointmentScheduledTime % 60 === 0">
                    {{ closestAppointmentScheduledTime / 60 }} h
                </span>
                <span class="complaint-info__data" *ngIf="closestAppointmentScheduledTime > 60 && closestAppointmentScheduledTime % 60 !== 0">
                    {{ (closestAppointmentScheduledTime - (closestAppointmentScheduledTime % 60)) / 60 }} h
                    {{ closestAppointmentScheduledTime % 60 }} min
                </span>
            </div>
          <button iccButton appearance="secondary" (click)="open(complaint)" class="complaint-info__button">
            {{ 'INTERFACE|Otwórz' | translate }} <icc-icon name="navigate_next"></icc-icon>
          </button>
        </div>
      </div>
  </ng-template>
